import { Injectable } from '@angular/core';
import { HouseholdState, HouseholdStore } from './household.store';
import { StateManagedJsonApi } from '@core/state/jsonentity/state-managed-json-api.service';
import { ApiService } from '@core/services/api/api.service';

@Injectable({providedIn: 'root'})
export class HouseholdService extends StateManagedJsonApi<HouseholdState> {
  protected endpoint = 'household';

  constructor(
    private store: HouseholdStore,
    private api: ApiService,
  ) {
    super(store, api);
  }
}
